import React, {Component} from 'react';
import {renderRoutes} from 'react-router-config';
import {connect} from 'react-redux';
import {createLocation} from 'history';
import PropTypes from 'prop-types';

import {generate} from '../../../routes.js';
import SearchView from '../../Search/Components/SearchView.jsx';
import Loader from '../../../../shared/components/Loader/Loader.jsx';

class OfferSearchViewContainer extends Component {
  static propTypes = {
    loading: PropTypes.bool,
  }

  static defaultProps = {
    loading: true,
  }

  goToEdit = (offer) => {
    this.props.history.push(createLocation(
      generate({
        name: 'offers.search.viewer.edit',
        parameters: {
          offer: offer.id,
          offset: this.props.match.params.offset,
          page: this.props.searchQuery.page,
        },
        search: this.props.flattenSearchObject(this.props.searchQuery)
      })
    ))
  };

  goToOffer = (offer) => {
    this.props.history.push(createLocation(
      generate({
        name: 'offers.search.viewer.views',
        parameters: {
          offer: offer.id,
          offset: this.props.match.params.offset,
          page: this.props.searchQuery.page,
        },
        search: this.props.flattenSearchObject(this.props.searchQuery)
      })
    ))
  };

  refresh = () => {
    this.props.history.push(createLocation(
      generate({
        name: this.props.searchRouteName,
        search: this.props.flattenSearchObject(this.props.searchQuery)
      })
    ));
    this.props.loadSearch(this.props.searchQuery);
  }

  render() {
    const {flattenSearchObject, isAdmin, loading, location, match, searchData, searchQuery, searchRouteName} = this.props;

    const offset = match?.params.offset;
    const offer = searchData?.results[offset] ?? null;

    let children = (
      <Loader visible={true} fill={false} contains={true} containsClassName="my-5">
        Recherche en cours...
      </Loader>
    );

    if (!loading && null !== offer) {
      children = (
        <div className="container offer-container">
          <div className="row">
            <div className="mx-auto col bg-white bd-gray-200">
              {renderRoutes(this.props.route.routes, {
                currentUser: this.props.currentUser,
                flattenOffer: this.props.flattenOffer,
                flattenSearch: flattenSearchObject,
                freelance: this.props.freelance,
                goToEdit: this.goToEdit,
                goToOffer: this.goToOffer,
                items: searchData?.results?.length ? searchData.results : [],
                liftOffer: this.props.liftOffer,
                loading: this.props.loading,
                offer: this.props.liftOffer(offer),
                searchQuery: this.props.searchQuery,
                pagination: this.props.pagination,
                refresh: this.refresh,
                search: this.props.search,
              })}
            </div>
          </div>
        </div>
      );
    }

    return (
      <SearchView
        flattenSearchObject={flattenSearchObject}
        isAdmin={isAdmin}
        location={location}
        match={match}
        searchData={searchData}
        searchQuery={searchQuery}
        searchRouteName={searchRouteName}
        title={offer ? offer.title : ''}
        viewRouteName="offers.search.viewer"
      >
        {children}
      </SearchView>
    );
  }
}

export default connect(
  (state) => ({
    searchData: state.search,
  }),
)(OfferSearchViewContainer);